import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { ERROR_MESSAGES } from "../../constants/enums";
import { ICallContext } from "./mirtapbxCallContext.types";

export interface ICreateCallContextPayload {
  dest: string;
  extension: string;
  customer_id?: number | null;
  customer_policy_id?: number | null;
  lead_id?: string | null;
}

export const createCallContextAsync = createAsyncThunk<
  { call_ref: string },
  ICreateCallContextPayload,
  { rejectValue: { message: string; status?: number } }
>("mirtapbxCallContext/createCallContext", async (payload, { rejectWithValue }) => {
  try {
    const res = await api.post("/mirtapbx/calls/context", payload);
    const data = res.data.data || res.data;
    return { call_ref: data.call_ref };
  } catch (err: any) {
    return rejectWithValue({
      message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
      status: err.response?.status,
    });
  }
});

export const pollCallContextAsync = createAsyncThunk<
  ICallContext,
  string,
  { rejectValue: { message: string; status?: number } }
>("mirtapbxCallContext/pollCallContext", async (call_ref, { rejectWithValue }) => {
  try {
    const res = await api.get(`/mirtapbx/calls/context/${call_ref}`);
    return res.data.data || res.data;
  } catch (err: any) {
    return rejectWithValue({
      message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
      status: err.response?.status,
    });
  }
});
